<template>
  <div class="opt-dialog">
    <header>VIP客户服务</header>
    <div class="content">
      <p>请您选择喜欢的咨询方式</p>
    </div>
    <footer>
      <div class="btn left" @click="toTel">电话客服</div>
      <div class="btn right" @click="toConsult">在线客服</div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'OptDialog',
  methods: {
    close() {
      this.$emit('close')
    },
    toTel() {
      this.$emit('tel')
    },
    toConsult() {
      this.$emit('consult')
    }
  }
}
</script>

<style scoped lang="less">
  @import 'OptDialog.less';
</style>
